import React from "react";
import PageHeader from "../../PageHeader";
import { ReactComponent as SubjectIcon } from "../../../images/subjectimage/subjecticon.svg";
import { ReactComponent as BackIcon } from "../../../images/pageheadingicon/backicon.svg";
import useStyles from "../../../../styles";
import AddAllocatedCenterForm from "./AddAllocateCenterForm";

function AddAllocationCenter() {
  const classes = useStyles();
  const Heading = [
    {
      id: 1,
      pageicon: <SubjectIcon />,
      mainheading: "Center",
      // subhead: "Want to Add in Bulk ? ?",
      // downloadlink: "Download bulk Sample Files",
      addbtntext: "Back",
      addbtnicon: <BackIcon />,
      addbtnstyle: "transparentbtn",
      path: "/admin/allocatedcenter",
    },
  ];
  return (
    <div className={`${classes.p2} ${classes.pb0}`}>
      <PageHeader Heading={Heading} />
      <AddAllocatedCenterForm />
    </div>
  );
}
export default AddAllocationCenter;
